import { useEffect } from 'react';
import { X, AlertTriangle, CheckCircle, Info } from 'lucide-react';
import clsx from 'clsx';

const ICONS = {
  success: CheckCircle,
  warning: AlertTriangle,
  error: AlertTriangle,
  info: Info,
};

const STYLES = {
  success: 'bg-success-50 dark:bg-success-500/10 border-success-200 dark:border-success-500/30 text-success-800 dark:text-success-400',
  warning: 'bg-amber-50 dark:bg-amber-500/10 border-amber-200 dark:border-amber-500/30 text-amber-800 dark:text-amber-400',
  error: 'bg-danger-50 dark:bg-danger-500/10 border-danger-200 dark:border-danger-500/30 text-danger-800 dark:text-danger-400',
  info: 'bg-blue-50 dark:bg-blue-500/10 border-blue-200 dark:border-blue-500/30 text-blue-800 dark:text-blue-400',
};

export default function Toast({ id, type = 'info', message, onDismiss, duration = 4000 }) {
  const Icon = ICONS[type];

  useEffect(() => {
    if (duration <= 0) return;
    const timer = setTimeout(() => onDismiss(id), duration);
    return () => clearTimeout(timer);
  }, [id, duration, onDismiss]);

  return (
    <div
      className={clsx(
        'flex items-start gap-3 p-4 rounded-xl border shadow-lg animate-fade-in',
        STYLES[type]
      )}
      role="alert"
    >
      <Icon size={18} className="mt-0.5 flex-shrink-0" />
      <p className="text-sm font-medium flex-1">{message}</p>
      <button onClick={() => onDismiss(id)} className="p-0.5 hover:opacity-70 transition-opacity" aria-label="Dismiss">
        <X size={14} />
      </button>
    </div>
  );
}
